var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0H4.5C2.3 0 0.52 1.8 0.52 4L0.5 28C0.5 30.2 2.3 32 4.5 32H36.5C38.7 32 40.5 30.2 40.5 28V4C40.5 1.8 38.7 0 36.5 0ZM36.5 28H4.5V8L20.5 18L36.5 8V28ZM20.5 14L4.5 4H36.5L20.5 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmEmail);
export default __webpack_public_path__ + "static/media/sm-email.0a84766d.svg";
export { ForwardRef as ReactComponent };